import Vue from 'vue'

export default {
    UPDATE_GIFT (state, value) {
        Vue.set(state, 'gifts', value);
    },
    SET_GIFTS (state, value) {
        this.commit('UPDATE_GIFT', value);
    },
    SET_SELECTED_GIFT (state,  value ) {
      Vue.set(state, 'selectedGift', value);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/gifts/mutations.js